import { CatalogType } from "src/api-service";

// **************************************************************************
// CATALOG TYPE STATE
// **************************************************************************
export interface CatalogTypeState {
    catalogType: CatalogType | null;
    catalogTypes: CatalogType[];
    catalogTypesLoading: boolean;
}

export const initialCatalogTypeState: CatalogTypeState = {
    catalogType: null,
    catalogTypes: [],
    catalogTypesLoading: false,
};
